import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CmsDataSettings } from 'src/app/models/cmsdata';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public settings: CmsDataSettings;
  public bgImage: string = "unset";
  public infoActive: boolean = false;
  public artistsActive: boolean = false;
  public artistsButtonEnabled: boolean = true;
  
  constructor(
    private utilService: UtilService,
    private router: Router,
    private dataService: DataService
  ) { 
    this.subscribe();
  }

  ngOnInit(): void {
    if (environment.envName === "phase1") {
      this.artistsButtonEnabled = false;
    }
  }

  subscribe() {
    // Customize based on settings data
    this.dataService.settings.subscribe((data) => {
      this.settings = data;
      if (data.footer_background) {
        this.bgImage = `url('${data.footer_background}')`;
      } else {
        this.bgImage = "unset";
      }
    });
    // Active button depends on current route
    this.router.events.subscribe((route: ActivatedRoute) => {
      if (route instanceof NavigationEnd) {
        this.setActive(route.url);
      }
    });
    this.setActive(location.pathname);
  }

  setActive(url: string) {
    if (url === "/map/info") {
      this.infoActive = true;
      this.artistsActive = false;
    } else if  (url === "/map/artists") {
      this.infoActive = false;
      this.artistsActive = true;
    } else {
      this.infoActive = false;
      this.artistsActive = false;
    }
  }

  toggleInfo() {
    //this.utilService.toggleModal();
    if (this.router.url === "/map/info") {
      this.router.navigate(["/map"]);
    } else {
      this.router.navigate(["/map/info"]);
    }
  }

  toggleArtists() {
    //this.utilService.toggleModal();
    if (this.router.url === "/map/artists") {
      this.router.navigate(["/map"]);
    } else {
      this.router.navigate(["/map/artists"]);
    }
  }

}